const themeConfigArr = [
    {
        name: "t3.bg2",
        vars: {
            "--bg-primary": "#157d6b",
            "--bg-primary90": "#157d6bE6",
            "--text-primary": "#FFFFFF",
            "--bg-secondary": "#0b0b09",
            "--bg-secondary70": "#0b0b09B3",
            "--bg-secondary85": "#0b0b09D9",
            "--text-secondary": "#FFFFFF",

            // '--theme1-bg': '#157d6b',
            // '--theme1-bg90': '#070707',
            // '--theme2-bg': '#0b0b09',
            // '--theme2-bg70': '#080808',
            // '--theme2-bg85': '#080808',
            // '--primary-color': '#fff',
            // '--secondary-color': '#fff',
        },
    },
    {
        name: "t3.bg3",
        vars: {
            "--bg-primary": "#04A1A6",
            "--bg-primary65": "#04A1A6a5",
            "--bg-primary90": "#04A1A6e6",
            "--text-primary": "#fff",
            "--bg-secondary": "#2c3e50",
            "--bg-secondary70": "#2c3e50b3",
            "--bg-secondary85": "#2c3e50d9",
            "--text-secondary": "#fff",

            //    --bg-primary: #04A1A6;
            //     --bg-primary90: #04A1A6E6;
            //     --text-primary: #FFFFFF;
            //     --bg-secondary: #0F696E;
            //     --bg-secondary70: #0F696EB3;
            //     --bg-secondary85: #0F696ED9;
            //     --text-secondary: #FFFFFF;
            //     --bg-news: ;
        },
    },
    {
        name: "t3.bg4",
        vars: {
            "--bg-primary": "#000000",
            "--bg-primary65": "#000000a5",
            "--bg-primary90": "#000000e6",
            "--text-primary": "#FFFFFF",
            "--bg-secondary": "#BD2525",
            "--bg-secondary70": "#BD2525b3",
            "--bg-secondary85": "#BD2525d9",
            "--text-secondary": "#FFFFFF",

            // --bg-primary: #000000;
            // --bg-primary90: #000000E6;
            // --text-primary: #FFFFFF;
            // --bg-secondary: #BD2525;
            // --bg-secondary70: #BD2525B3;
            // --bg-secondary85: #BD2525D9;
            // --text-secondary: #FFFFFF;
            // --bg-news: ;
        },
    },
];

export default themeConfigArr;
